export default __webpack_public_path__ + "static/media/backward-key.af99d48b.svg";